import { TravailStubPage } from '../../../../components/parcours/TravailStubPage';
import { getTravailStub } from '../../../../config/travaux-particuliers';

export default function PompeAChaleurPage() {
  const travail = getTravailStub('pompe-a-chaleur');
  if (!travail) return null;
  return <TravailStubPage travail={travail} />;
}
